// Action Types
export const GET_PRESCRIPTIONS = "GET_PRESCRIPTIONS_BY_CASE_ID";
export const GET_PRESCRIPTION = "GET_PRESCRIPTION";
export const ADD_PRESCRIPTION = "ADD_PRESCRIPTION";
export const UPDATE_PRESCRIPTION = "UPDATE_PRESCRIPTION";
export const GET_MEDICINE_INVENTORY = "GET_MEDICINE_INVENTORY";
export const MEDICINE_INVENTORY_ERROR = "MEDICINE_INVENTORY_ERROR";
export const DOWNLOAD_PRESCRIPTION = "DOWNLOAD_PRESCRIPTION";

// Action Creators
export const getPrescriptions = (prescriptions) => ({
  type: GET_PRESCRIPTIONS,
  prescriptions,
});

export const getPrescription = (prescription) => ({
  type: GET_PRESCRIPTION,
  prescription,
});

export const addPrescriptionAction = (prescription) => ({
  type: ADD_PRESCRIPTION,
  prescription,
});

export const updatePrescriptionAction = (prescription) => ({
  type: UPDATE_PRESCRIPTION,
  prescription,
});

export const getMedicineInventoryAction = (medicineInventory) => ({
  type: GET_MEDICINE_INVENTORY,
  medicineInventory,
});

export const medicineInventoryErrorAction = (error) => ({
  type: MEDICINE_INVENTORY_ERROR,
  error,
});

export const downloadPrescriptionAction = (fileUrl) => ({
  type: DOWNLOAD_PRESCRIPTION,
  fileUrl,
});
